'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _pubsub = require('../../pubsub');

var _pubsub2 = _interopRequireDefault(_pubsub);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _modal = require('../modal');

var _modal2 = _interopRequireDefault(_modal);

var _graphDisplay = require('./graph-display.scss');

var _graphDisplay2 = _interopRequireDefault(_graphDisplay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var addSuffix = function addSuffix(fileurl, suffix) {
    return fileurl.substring(0, fileurl.lastIndexOf('.')) + '-' + suffix + fileurl.substring(fileurl.lastIndexOf('.'));
};

var GraphDisplay = function (_React$Component) {
    _inherits(GraphDisplay, _React$Component);

    function GraphDisplay(props) {
        _classCallCheck(this, GraphDisplay);

        var _this = _possibleConstructorReturn(this, (GraphDisplay.__proto__ || Object.getPrototypeOf(GraphDisplay)).call(this, props));

        _this.state = {
            currentIndex: 0,
            currentVariation: 'base',
            isOpen: false
        };

        _this.badgeEventId = -1;

        _this.onNavClick = _this.onNavClick.bind(_this);

        _this.images = _this.props.config.map(function (item) {
            var ids = item.ids.reduce(function (acc, val) {
                acc[val] = addSuffix(item.base, val);
                return acc;
            }, {});

            return _lodash2.default.assign({
                base: item.base
            }, ids);
        });

        _this.preloadImages();

        _this.closeModal = _this.closeModal.bind(_this);
        _this.enlargeImage = _this.enlargeImage.bind(_this);

        return _this;
    }

    _createClass(GraphDisplay, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.badgeEventId = _pubsub2.default.on('input.badge-select', function (name) {
                var index = -1;

                for (var i = _this2.images.length; i--;) {
                    if (_this2.images[i].hasOwnProperty(name)) {
                        index = i;
                        break;
                    }
                }

                _this2.setState({
                    currentIndex: index < 0 ? 0 : index,
                    currentVariation: index < 0 ? 'base' : name
                });
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _pubsub2.default.off(this.badgeEventId);
        }
    }, {
        key: 'preloadImages',
        value: function preloadImages() {
            var preload = function preload(url) {
                var img = new Image();
                img.src = url;
            };

            for (var i = this.images.length; i--;) {
                for (var key in this.images[i]) {
                    if (this.images[i].hasOwnProperty(key)) {
                        preload(this.images[i][key]);
                    }
                }
            }
        }
    }, {
        key: 'onNavClick',
        value: function onNavClick(e) {
            this.setState({
                currentIndex: Number(e.target.getAttribute('data-index')),
                currentVariation: 'base'
            }, function () {
                _pubsub2.default.trigger('graph-display.nav-click');
            });
        }
    }, {
        key: 'enlargeImage',
        value: function enlargeImage(e) {
            e.preventDefault();
            e.stopPropagation();

            this.setState({
                isOpen: true
            });
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.setState({
                isOpen: false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _state = this.state,
                currentIndex = _state.currentIndex,
                currentVariation = _state.currentVariation;


            return _react2.default.createElement(
                'div',
                { className: _graphDisplay2.default["graph-display"] },
                _react2.default.createElement(
                    'div',
                    { className: _graphDisplay2.default.nav },
                    this.props.config.map(function (item, index) {
                        return _react2.default.createElement('span', {
                            className: _graphDisplay2.default["nav-item"] + (index === _this3.state.currentIndex ? ' ' + _graphDisplay2.default["is-active"] : ''),
                            'data-index': index,
                            key: index,
                            onClick: _this3.onNavClick });
                    }),
                    _react2.default.createElement(
                        'span',
                        { className: _graphDisplay2.default['modal-trigger'], onClick: this.enlargeImage },
                        _react2.default.createElement(
                            'svg',
                            { viewBox: '0 0 16 16' },
                            _react2.default.createElement('circle', { fill: 'none', stroke: '#fff', strokeMiterlimit: '10', cx: '6.98', cy: '6.98',
                                r: '2.74' }),
                            _react2.default.createElement('line', { fill: 'none', stroke: '#fff', strokeMiterlimit: '10', x1: '8.84', y1: '8.98', x2: '11.93',
                                y2: '12.07' })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _graphDisplay2.default.display },
                    _react2.default.createElement('img', { src: this.images[this.state.currentIndex][this.state.currentVariation] })
                ),
                _react2.default.createElement(
                    _modal2.default,
                    {
                        id: 'product-type-' + this.props.id,
                        isOpen: this.state.isOpen,
                        escClose: true,
                        closeHandler: this.closeModal },
                    _react2.default.createElement(
                        'div',
                        { className: _graphDisplay2.default['modal-inner'] },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: _graphDisplay2.default['close-wrapper'] },
                                _react2.default.createElement(
                                    'span',
                                    { className: _graphDisplay2.default.close, onClick: this.closeModal },
                                    _react2.default.createElement(
                                        'svg',
                                        { viewBox: '0 0 50 50' },
                                        _react2.default.createElement('polygon', { fill: '#fff',
                                            points: '27.8,25 49.9,2.9 47.1,0.1 25,22.1 2.9,0.1 0,2.9 22.1,25 0,47.1 2.9,50 25,27.9 47.1,50 49.9,47.1 ' })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _graphDisplay2.default['image-wrapper'] },
                                _react2.default.createElement('img', { className: _graphDisplay2.default["full-img"],
                                    src: '' + this.images[currentIndex][currentVariation] })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return GraphDisplay;
}(_react2.default.Component);

GraphDisplay.propTypes = {
    config: _propTypes2.default.array.isRequired
};

exports.default = GraphDisplay;


//////////////////
// WEBPACK FOOTER
// ./client/components/graph-display/index.js
// module id = 184
// module chunks = 0